import html2canvas from "html2canvas";

export function saveScreenshot(thumbWidth, thumbHeight){
    return new Promise(function (resolve, reject) {
        try {
            if(document.querySelector("#workspace .scenes")){
                html2canvas(document.querySelector("#workspace .scenes"),{useCORS : true, logging : false})
                .then(function(canvas) {
                    var extra_canvas = document.createElement("canvas");
                    var projectUrl = "";
                    extra_canvas.setAttribute('width', thumbWidth * 2);
                    extra_canvas.setAttribute('height', thumbHeight * 2);
                    var ctx = extra_canvas.getContext('2d');
                    ctx.drawImage(canvas,0,0,canvas.width, canvas.height,0,0, thumbWidth * 2, thumbHeight * 2);
                    projectUrl = extra_canvas.toDataURL();
                    extra_canvas.remove();
                    resolve([projectUrl]);
                })
                .catch(reject)
            }else{
                resolve(null);
            }
            
        } catch (err) {
            reject(err);
        }
        

    })
  }


// WEBPACK FOOTER //
// ./src/helpers/ScreenshotHelper.js